<template>
  <div class="d-flex align-center ga-2">
    <v-btn
      v-if="showDownloadCsvButton"
      variant="outlined"
      height="36"
      rounded="lg"
      class="download-btn"
      :loading="csvDownloadLoading"
      :disabled="libraryLoading || csvDownloadLoading || hasNoResults || !csvDownloadEnabled"
      @click="handleDownloadCsv"
    >
      <v-icon
        icon="$tray-arrow-down"
        class="mr-2"
        size="small"
      />
      Download CSV
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useApprovalsDashboardStore } from '@/stores/jobProfiles/approvalsDashboard';

defineProps({
  libraryLoading: { type: Boolean, default: false },
});

const route = useRoute();

// TODO: Enable once the approvals export API is done.
const showDownloadCsvButton = false;

const {
  flows,
  csvDownloadLoading,
  csvDownloadEnabled,
} = storeToRefs(useApprovalsDashboardStore());
const { downloadCsv } = useApprovalsDashboardStore();

const hasNoResults = computed(() => !flows.value?.length);

const handleDownloadCsv = () => {
  downloadCsv(route.query);
};
</script>

<style lang="less" scoped>
.download-btn {
  border: 1px solid @stroke-default;
  color: @text-dark;
  background: @white;
}
</style>
